const state = {
  appId: '',
  appAuditId: '',
  isAddEdition: false
}

const mutations = {
  setAppId: (state, value) => {
    state.appId = value
  },
  setAppAuditId: (state, value) => {
    state.appAuditId = value
  },
  setAddEdition: (state) => {
    state.isAddEdition = true
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

